/** * 報告書コンポーネント */
<template>
  <b-container id="the-reports" class="container-report">
    <!-- 検索ツールバー -->
    <div class="tool-bar">
      <b-form-row class="tool-bar-form">
        <!-- 報告書プロジェクト選択 -->
        <b-col>
          <report-project-selector
            v-bind:selectedAllLabel="$t('theReport.allReportProject')"
            v-bind:selectedProjectID="defaultProjectId || undefined"
            v-on:change-report-project="$_changeReportProject"
          ></report-project-selector>
        </b-col>
        <!-- プレイス選択 -->
        <b-col>
          <place-selector
            ref="place-selector"
            v-bind:selectType="1"
            v-bind:selectedAllPlaceLabel="$t('theReport.allPlaces')"
            v-bind:defaultPlaces="defaultPlaceIds"
            v-bind:keywordTarget="keywordTargets"
            v-bind:onApiError="handleApiError"
            v-on:place-selectend="$_fixSelectedPlaces"
            v-on:place-keyword-target-selectend="$_onKeywordTargetChange"
          ></place-selector>
        </b-col>
        <!-- 報告者選択 -->
        <b-col>
          <user-selector
            v-bind:defaultText="$t('theReport.allReporters')"
            v-bind:keywordTarget="
              $store.getters['userKeywordTarget/keywordTargets']
            "
            v-bind:onApiError="handleApiError"
            v-bind:indoorSites="$store.getters['indoorSite/indoorSites']"
            v-bind:targetUserType="'app'"
            v-on:change:value="$_fixSelectedUsers"
            v-on:change:keywordTarget="
              $store.dispatch('userKeywordTarget/setKeywordTargets', $event)
            "
          ></user-selector>
        </b-col>
        <!-- 検索期間 -->
        <b-col>
          <datetime-selector
            v-bind:fieldLabel="$t('theReport.reportingDate')"
            v-bind:periodString="null"
            v-bind:periodFlg="true"
            v-bind:startDate="defaultStartDate"
            v-bind:endDate="defaultEndDate"
            v-on:datetime-selectend="$_changeSearchPeriod"
          ></datetime-selector>
        </b-col>
        <!-- キーワード検索 -->
        <b-col>
          <input-keyword
            v-model="searchKeyword"
            v-bind:placeholder="$t('theReport.placeholder.searchKeyword')"
            v-on:search="$_onSearchKeyword"
          />
        </b-col>
      </b-form-row>
    </div>
    <b-row no-gutters class="content-wrapper">
      <!-- 報告書一覧 -->
      <b-col cols="4" class="view-list" v-show="isListViewShown">
        <!-- タイトルバー -->
        <b-row class="title-bar">
          <b-col class="title-bar-between title-bar-list">
            <!-- 報告書件数 -->
            <h1>
              {{ $tc('theReport.numberOfReport', reportTotalCount) }}
            </h1>
            <div class="title-bar-action">
              <!-- 更新 -->
              <div class="title-bar-reload">
                <div class="label" v-show="listUpdatedDateLabel">
                  {{ $t('theReport.listUpdate.field') }} :
                  {{ listUpdatedDateLabel }}
                </div>
                <button-reload v-on:click="$_onClickReload" />
              </div>
              <!-- 作成ボタン -->
              <b-button
                variant="light"
                v-ifield-b-tooltip.hover
                v-bind:title="$t('theReport.action.createReport')"
                class="button-create"
                v-on:click="$_showEditDialog"
              >
                <icon-report class="icon" />
                <span v-t="'theReport.action.create'" />
              </b-button>
            </div>
          </b-col>
        </b-row>
        <!-- 一覧 -->
        <div class="list-wrapper">
          <loading-mask v-bind:isLoading="isLoading">
            <!-- 報告書のヘッダー -->
            <div class="list-header">
              <!-- 全て表示/承認/未承認 検索ボタン-->
              <filter-button-group
                v-model="currentCheckedTypes"
                v-bind:buttons="checkedFilterButtons"
                v-bind:label="$t('theReport.display')"
              />
            </div>
            <dynamic-scroller
              class="list-inner"
              ref="report-list-inner"
              v-bind:items="reportsForCard"
              v-bind:min-item-size="210"
              v-slot="{ item, index, active }"
            >
              <dynamic-scroller-item
                v-bind:item="item"
                v-bind:active="active"
                v-bind:index="index"
                v-bind:size-dependencies="[item.comment]"
              >
                <div class="report-detail-content">
                  <!-- 報告書 -->
                  <card-report
                    v-bind="item"
                    v-on:reportcard-click="$_onClickCardBody"
                    v-on:reportcard-title-click="$_onClickCardTitle"
                    v-on:reportcard-detail-click="$_onClickCardDetail"
                  />
                  <div class="spacer" />
                </div>
              </dynamic-scroller-item>
            </dynamic-scroller>
            <!-- 一覧フッター -->
            <b-row class="list-footer">
              <!-- 表示件数 -->
              <b-col cols="3" class="list-limit">
                <b-form-select
                  size="sm"
                  v-bind:options="listLimitSelectValues"
                  v-bind:value="listLimit"
                  v-on:change="$_onChangeListLimit"
                ></b-form-select>
              </b-col>
              <!-- ページネーション -->
              <b-col cols="6">
                <b-pagination
                  v-model="currentReportPage"
                  v-bind:total-rows="reportTotalCount"
                  v-bind:per-page="listLimit"
                  align="center"
                  size="sm"
                  class="report-pagination"
                ></b-pagination>
              </b-col>
              <b-col cols="3"></b-col>
            </b-row>
          </loading-mask>
        </div>
        <!-- </div> -->
      </b-col>
      <!-- 地図 -->
      <b-col v-bind:cols="viewCols.right" class="view-map">
        <map-control
          ref="map-control"
          id="report-map-control"
          v-bind="$store.getters.mapControlBinds"
          v-bind:id-prefix="'report-'"
          v-bind:reactive-render="!isModalOverlaid"
          v-bind:bounds="bounds"
          v-bind:layer-renderers="renderers"
          v-bind:layer-menu-data="layerMenuData"
          v-bind:onIfieldApiError="handleApiError"
          v-on:indoor-level-selected="setActiveIndoorLevelId"
          v-on:map-control-initend="$_onMapInitEnd"
          v-on:menu-layers-visible-changed="$_onLayerMenuVisibleChanged"
        >
          <template v-slot:default="{ currentMapComponent, zoom, center }">
            <template v-for="cluster in clusters">
              <map-popup
                v-if="cluster.fixPopup || cluster.showPopup"
                v-bind:key="`${cluster.id}-report-cluster-popup`"
                v-bind:id-prefix="'report'"
                v-bind:current-map-component="currentMapComponent"
                v-bind:map-center="center"
                v-bind:map-zoom="zoom"
                v-bind:coordinates="cluster.geometry.coordinates"
                v-bind:data="cluster"
                v-bind:offset="popup.offset"
                v-bind:placement="popup.placement"
                v-on:shown="popup.id = $event"
                v-on:hidden="popup.id = null"
                v-on:popup-mouseenter="onPopupMouseEnter"
                v-on:popup-mouseleave="onPopupMouseLeave"
              >
                <template v-slot:default="{ data }">
                  <map-popup-content-report
                    v-bind:data="data.properties.children"
                    v-bind:sort-key="'report_update_at'"
                    v-bind:sort-direction="'desc'"
                    v-on:detail-click="$_showReportDialog"
                  />
                </template>
              </map-popup>
            </template>
          </template>
          <template v-slot:map-left-top>
            <!-- ビル表示ボタン -->
            <map-indoor-building-button
              v-bind:indoor-building="
                $store.getters['mapIndoor/activeIndoorBuilding']
              "
              class="map-control-ui"
              v-on:reset-click="unselectedBuilding"
            />
            <!-- リスト切り替えタブ -->
            <list-view-toggle-tab
              v-model="isListViewShown"
              v-bind:listViewCols="viewCols.left"
              v-bind:idPrefix="'report'"
              class="map-control-ui list-tab"
              v-on:listview-toggletab-toggled="$_toggleListViewShown"
            />
          </template>
        </map-control>
      </b-col>
    </b-row>
    <report-detail ref="report-detail" v-on:hide-modal="$_onHideReportDetail" />
    <place-detail
      ref="place-detail"
      v-on:place-searchreport-click="$_changeSelectedPlaces"
      v-on:place-searchuser-click="$_showMember"
      v-on:hide-modal="$_onHidePlaceDetail"
    />
    <!-- 編集ダイアログ -->
    <report-editor
      ref="report-editor"
      v-on:report-editend="$_onReportEditEnd"
    />
    <!-- モーダル重畳検知 -->
    <modal-overlay-detector
      v-on:is-modal-overlaid-changed="$_onModalOverlayChanged"
    />
  </b-container>
</template>

<script>
import ReportProjectSelector from '@/components/AppReportProjectSelector.vue'
import ButtonReload from '@/components/AppButtonReload.vue'
import FilterButtonGroup from '@/components/AppFilterButtonGroup.vue'
import CardReport from '@/components/report/AppCardReport.vue'
import ListViewToggleTab from '@/components/AppListViewToggleTab.vue'
import ReportDetail from '@/views/TheReportDetail.vue'
import ReportEditor from '@/views/TheReportEditor.vue'
import PlaceDetail from '@/views/ThePlaceDetail.vue'
import BvModalOverlayDetector from '@/components/AppBvModalOverlayDetector.vue'
import { RestApiClient } from 'ifield-core-components'
import { MapPopup } from 'ifield-core-components'
import { MapIndoorBuildingButton } from 'ifield-core-components'
import MapPopupContentReport from '@/components/report/AppMapPopupContentReport.vue'
import DomainRenderer from '@/js/map-renderer/DomainRenderer.js'
import GeometryUtil from '@/js/util/GeometryUtil.js'
import IconReport from '@/assets/ifield/ic_report.svg?component'
import VARIABLES from '@/assets/scss/variables.module.scss'
import _ from 'lodash'
import moment from 'moment'
import ModalUtil from '@/js/util/ModalUtil.js'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { shallowRef, inject } from 'vue'
import { mapState, mapGetters } from 'vuex'
import {
  FUNCTION_TYPE,
  DATE_FORMAT_HYPHEN,
  TIME_FORMAT_MILLISECOND,
  CLUSTER_ICON_ID,
  CLUSTERING_MAP_ID,
  CLUSTER_ICON_TEXT_COLOR,
} from '@/constants.js'
import { toLocalTz, toServerTz } from '@/js/TimezoneHelper'
import { useHandleApiError } from '@/composables/UseHandleApiError.js'
import { useMapIndoorStore } from '@/composables/map/UseMapIndoorStore'
import { useClusterPopup } from '@/composables/map/UseClusterPopup.js'

/**
 * 検索対象の承認状態(定数)
 */
const CHECKED_TYPES = {
  ALL: 'all',
  UNCHECKED: 'unchecked',
  CHECKED: 'checked',
}

/** すべてのレポートプロジェクトID */
const ALL_PROJECTS_ID = -1

/**
 * ミリ秒日時フォーマット
 */
const DATETIME_FORMAT_MILLISECOND = `${DATE_FORMAT_HYPHEN}T${TIME_FORMAT_MILLISECOND}`

// レイヤーID
const LAYER_ID = 'report'

// レンダラーファクトリ
const rendererFactory = new DomainRenderer({ layerId: LAYER_ID })

export default {
  name: 'TheReport',
  components: {
    'button-reload': ButtonReload,
    'icon-report': IconReport,
    'filter-button-group': FilterButtonGroup,
    'card-report': CardReport,
    'report-project-selector': ReportProjectSelector,
    'report-detail': ReportDetail,
    'report-editor': ReportEditor,
    'map-popup': MapPopup,
    'map-popup-content-report': MapPopupContentReport,
    'map-indoor-building-button': MapIndoorBuildingButton,
    'list-view-toggle-tab': ListViewToggleTab,
    'place-detail': PlaceDetail,
    'dynamic-scroller': DynamicScroller,
    'dynamic-scroller-item': DynamicScrollerItem,
    'modal-overlay-detector': BvModalOverlayDetector,
  },
  props: {
    /**
     * 初期報告書プロジェクトID
     */
    defaultProjectId: {
      type: Number,
      default: null,
    },
    /**
     * 初期プレイスID
     */
    defaultPlaceIds: {
      type: Array,
      default: () => [],
    },
    /**
     * 初期開始日付
     */
    defaultStartDate: {
      type: String,
      default: null,
    },
    /**
     * 初期終了日付
     */
    defaultEndDate: {
      type: String,
      default: null,
    },
    /**
     * 初期キーワード
     */
    defaultKeyword: {
      type: String,
      default: null,
    },
  },
  setup(props, context) {
    /**
     * AppMapControlのインスタンス
     */
    const map = shallowRef(null)

    const { handleApiError } = useHandleApiError(props, context)
    const { unselectedBuilding, setActiveIndoorLevelId } = useMapIndoorStore()
    const {
      popup,
      isClusterHoverd,
      isPopupHoverd,
      clusters,
      hoveredCluster,
      isCluster,
      onClickCluster,
      onHoverCluster,
      onPopupMouseEnter,
      onPopupMouseLeave,
      areClustersEqual,
      getFixPopupFromCurrentClusterInfo,
    } = useClusterPopup()
    const baseDate = inject('baseDate')
    return {
      map,
      handleApiError,
      unselectedBuilding,
      setActiveIndoorLevelId,
      popup,
      isClusterHoverd,
      isPopupHoverd,
      clusters,
      hoveredCluster,
      isCluster,
      onClickCluster,
      onHoverCluster,
      onPopupMouseEnter,
      onPopupMouseLeave,
      areClustersEqual,
      getFixPopupFromCurrentClusterInfo,
      baseDate,
    }
  },
  data: function () {
    return {
      /**
       * ページが表示されている場合はtrue
       * keep-alive で保持されるため、非表示でも破棄されない
       * @type {Boolean}
       */
      isViewActive: true,
      /**
       * 検索条件に一致した報告書一覧
       * @type {Array}
       */
      reports: [],
      /**
       * 検索条件に一致した報告書の全データ件数
       * @type {number}
       */
      reportTotalCount: null,
      /**
       * 選択中の報告書プロジェクトID
       * @type {number}
       */
      currentProjectId: this.defaultProjectId,
      /**
       * 選択中のプレイスIDリスト
       */
      currentPlaceIds: this.defaultPlaceIds,
      /**
       * 選択中ユーザーID
       */
      currentUserIds: [],
      /**
       * 選択中グループID
       */
      currentOrganizationIds: [],
      /**
       * 現在選択している検索期間
       */
      searchPeriod: {
        /** 開始日 */
        startDate: this.defaultStartDate,
        /** 終了日 */
        endDate: this.defaultEndDate,
      },
      /**
       * 検索キーワード
       * @type {string}
       */
      searchKeyword: this.defaultKeyword,
      /**
       * 比較用検索キーワード
       * @type {string}
       */
      previousKeyword: '',
      /**
       * 現在選択している検索対象の承認状態
       */
      currentCheckedTypes: CHECKED_TYPES.ALL,
      /**
       * 現在選択している報告書一覧のページ番号
       * @type {number}
       */
      currentReportPage: 1,
      /**
       * リストビューを表示する場合true
       * @type {Boolean}
       */
      isListViewShown: true,
      /**
       * 一覧表示の最終更新日時
       * @type {Date}
       */
      listUpdatedDate: null,
      /**
       * ロード中の場合はtrue
       * @type {Boolean}
       */
      isLoading: false,
      /**
       * モーダルが重畳している場合はtrue
       * @type {Boolean}
       */
      isModalOverlaid: false,
      /**
       * 一覧の1ページあたりの表示件数
       * @type {number}
       */
      listLimit: this.$store.state.report.listLimit.value,
      /**
       * レイヤー表示状態
       * @type {Boolean}
       */
      visible: true,
      /**
       * 自データのレイヤーレンダラー
       * @type {Object}
       */
      myRenderer: null,
      // リロード中フラグ
      isReloading: false,
    }
  },
  computed: {
    ...mapGetters('mapLayer', ['clickedPlace']),
    ...mapGetters('place', ['keywordTargets']),
    ...mapState('map', ['zoom']),
    ...mapState('reportMarker', ['iconAtlas', 'iconMapping']),
    ...mapState({
      /**
       * 一覧の1ページあたりの表示件数の選択リスト値
       * @type {Array<number>}
       */
      listLimitSelectValues: (state) => state.report.listLimit.selectValues,
    }),
    /**
     * クラスタリング実行フラグ
     * @type {Boolean}
     */
    enableClustering: function () {
      return this.$store.getters.isClusteringEnabled(CLUSTERING_MAP_ID.REPORT)
    },
    /**
     * 報告書カード用データ
     * @type {Array.<Object>}
     */
    reportsForCard: function () {
      return this.reports.map((report) => ({
        id: report.id,
        reportTitle: report.title,
        reportComment: report.comment,
        iconImagePath: report.icon_image_path,
        placeName: report.place_name,
        projectId: report.report_project_id,
        projectName: report.report_project_name,
        projectImageAttachFileType:
          report.report_project_image?.attach_file_type || FUNCTION_TYPE.REPORT,
        isChecked: report.checked_flg,
        attachFilesCount: report.report_attach_files
          ? report.report_attach_files.length
          : 0,
        reportUserId: report.report_user_id,
        reportUserName: report.report_user_name,
        reportUserProfileAttachFileType: report.report_user_profile_image
          ? report.report_user_profile_image.attach_file_type
          : null,
        updateAt: report.report_update_at,
        baseDate: this.baseDate,
        groups:
          this.$store.getters['user/getUserById'](report.report_user_id)
            ?.groups || [],
      }))
    },
    /**
     * 地図binding用render関数配列
     * @type {Array.<Function>}
     */
    renderers: function () {
      const renderers = [...this.$store.getters['map/layerRenderers']]
      if (this.myRenderer) {
        renderers.push(this.myRenderer.render)
      }
      return renderers
    },
    /**
     * レイヤーメニュー用データ
     * @type {Array.<Object>}
     */
    layerMenuData: function () {
      const data = [...this.$store.getters['map/layerMenu/layerMenuData']]
      if (this.myRenderer) {
        data.unshift({
          id: this.myRenderer.id,
          name: this.$t('theReport.layer.report'),
          visible: this.visible,
          geometryTypes: ['Point'],
          color: VARIABLES.ENTITY_COLOR_BLUE,
        })
      }
      return data
    },
    /**
     * reportのbounds
     * @type {Object}
     */
    bounds: function () {
      if (!this.reports.length) return null
      return GeometryUtil.getBounds(this.reports.map((c) => c.geom)).toObject()
    },
    /**
     * 承認状態絞り込みボタン
     * @type {Array.<Object>}
     */
    checkedFilterButtons: function () {
      return [
        { value: CHECKED_TYPES.ALL, text: this.$t('theReport.filter.all') },
        {
          value: CHECKED_TYPES.UNCHECKED,
          text: this.$t('theReport.filter.unchecked'),
        },
        {
          value: CHECKED_TYPES.CHECKED,
          text: this.$t('theReport.filter.checked'),
        },
      ]
    },
    /**
     * 現在選択している検索対象の位置確定種別が「すべて」の場合にtrueを返却する
     */
    isSelectedCheckedTypeAll: function () {
      return this.currentCheckedTypes === CHECKED_TYPES.ALL
    },
    /**
     * 現在選択している検索対象の位置確定種別が「位置未確定」の場合にtrueを返却する
     */
    isSelectedCheckedTypeUnchecked: function () {
      return this.currentCheckedTypes === CHECKED_TYPES.UNCHECKED
    },
    /**
     * 現在選択している検索対象の位置確定種別が「位置確定済み」の場合にtrueを返却する
     */
    isSelectedCheckedTypeChecked: function () {
      return this.currentCheckedTypes === CHECKED_TYPES.CHECKED
    },
    /**
     * ビュー分割のcol数
     */
    viewCols: function () {
      return this.isListViewShown
        ? { left: 4, right: 8 }
        : { left: 0, right: 12 }
    },
    /**
     * 表示用の一覧の最終更新日
     * @return {string}
     */
    listUpdatedDateLabel: function () {
      if (!this.listUpdatedDate) {
        return ''
      }
      return moment(this.listUpdatedDate).format(
        this.$t('theReport.listUpdate.format')
      )
    },
    /**
     * キーワードが変更された場合はtrue
     * @type {Boolean}
     */
    isKeywordChanged: function () {
      return this.searchKeyword != this.previousKeyword
    },
  },
  watch: {
    reports: function () {
      this.$_updatePinImage(this.isReloading)
        .then(() =>
          this.$store.dispatch('reportMarker/updateTexture', this.isReloading)
        )
        .then(() => {
          this.$_updateReportLayer()
          this.isReloading = false
        })
    },
    currentReportPage: function () {
      this.$_showReportData()
    },
    currentCheckedTypes: function () {
      this.$_showReportData()
    },
    zoom: function () {
      // レイヤー更新
      this.reports.length && this.$_updateReportLayer()
    },
    visible: function () {
      this.$_updateReportLayer()
    },
    enableClustering: function () {
      this.$_updateReportLayer()
    },
    iconAtlas: function () {
      this.$_updateReportLayer()
    },
    clickedPlace(value) {
      // Click された Feature が変更された
      // プレイス詳細ダイアログを表示する
      this.$log.debug('[clickedPlace] ', value)
      // 保持されている非表示のページでも watcher は動くので、表示中のページだけが開く
      if (value && this.isViewActive && !this.isModalOverlaid) {
        this.$_showPlaceDialog(value.properties.place_id)
      }
    },
  },
  created: function () {
    this.$_updateMapLayers()
    this.$_updateUsers()
    this.$_updateIndoorSites()
  },
  mounted: function () {
    this.$_showReportData()
    this.$log.debug('theReport mounted.')
  },
  activated: function () {
    // 初回描画時は created / mounted で初期化済みなので何もしない
    if (this.isViewActive) return
    this.$log.debug('theReport activated.')
    this.isViewActive = true
    // 他のページから渡された検索条件を読み直して一覧を取得し直す
    this.$_applyDefaultSearchCondition()
    this.$_showReportData()
  },
  deactivated: function () {
    this.$log.debug('theReport deactivated.')
    this.isViewActive = false
    // 開いたままのダイアログを閉じる
    ModalUtil.hideAllIn(this)
  },
  methods: {
    /**
     * 他のページから渡された検索条件を反映する
     *
     * data の初期値としてしか読んでいないため、ページを保持したままだと
     * 2回目以降に渡された値が反映されない。ページを表示するたびに読み直す。
     * ナビゲーションから遷移した場合は値が渡されないので、そのときは
     * 表示していたときの検索条件をそのまま残す。
     */
    $_applyDefaultSearchCondition: function () {
      if (this.defaultProjectId) {
        this.currentProjectId = this.defaultProjectId
      }
      if (this.defaultPlaceIds.length) {
        this.currentPlaceIds = this.defaultPlaceIds
      }
      if (this.defaultStartDate) {
        this.searchPeriod.startDate = this.defaultStartDate
      }
      if (this.defaultEndDate) {
        this.searchPeriod.endDate = this.defaultEndDate
      }
      if (this.defaultKeyword) {
        this.searchKeyword = this.defaultKeyword
      }
    },

    /**
     * マップレイヤー更新
     */
    $_updateMapLayers: async function () {
      try {
        await this.$store.dispatch('mapLayer/updateMapLayersWithThrottle')
      } catch (error) {
        this.handleApiError(error, () =>
          this.$log.warn('failed to fetch maplayers. use fetched before.')
        )
      }
    },

    /**
     * ユーザー更新
     */
    $_updateUsers: async function () {
      try {
        await this.$store.dispatch('user/updateUsersWithThrottle')
      } catch (error) {
        this.handleApiError(error, () =>
          this.$log.warn('failed to fetch users. use fetched before.')
        )
      }
    },

    /**
     * サイトデータ更新
     */
    $_updateIndoorSites: async function () {
      try {
        this.$store.dispatch('indoorSite/updateIndoorSitesWithThrottle')
      } catch (error) {
        this.handleApiError(error, () => {
          this.$log.info('failed to fetch indoor sites. use fetched before.')
        })
      }
    },

    /**
     * ベースマップ初期化完了時処理
     */
    $_onMapInitEnd: function () {
      this.map = this.$refs['map-control']
    },

    /**
     * レイヤーの表示状態変更イベントの処理
     * @param {Array.<Object>} value 表示状態変更値
     */
    $_onLayerMenuVisibleChanged: function (value) {
      for (const { id, visible } of value) {
        if (id === LAYER_ID) {
          this.visible = visible
        }
      }
      this.$store.dispatch('map/setVisible', value)
    },

    /**
     * 報告書データを表示する
     * @param {String} レイヤ表示名称
     */
    $_showReportData: function () {
      this.$_showReportList()
      this.$_showReportTotalCount()
    },

    /**
     * 報告書一覧を表示する
     */
    $_showReportList: async function () {
      this.$_showLoading()
      // URL作成
      var url = RestApiClient.createApiUrl('report')
      var params = url.searchParams
      // 検索条件追加
      this.$_addSearchCondition(params)
      // limit, offset
      params.append('limit', this.listLimit)
      var offset = (this.currentReportPage - 1) * this.listLimit
      if (offset >= 1) {
        // offsetに0を設定するとAPIエラーになってしまうため、1以上の場合のみ設定する
        params.append('offset', offset)
      }

      try {
        const json = await RestApiClient.executeGetApi(url)
        this.reports = json.data.map((d) => ({
          ...d,
          report_create_at: toLocalTz(d.report_create_at),
          report_update_at: toLocalTz(d.report_update_at),
        }))
      } catch (error) {
        this.handleApiError(error)
        this.$_hideLoading()
        return
      }

      // 変更検知用に前回キーワードを保持
      this.previousKeyword = this.searchKeyword
      // 一覧のスクロールバーを先頭に戻す
      this.$_scrollListToTop()
      // 更新日時を更新する
      this.listUpdatedDate = Date.now()

      this.$_hideLoading()
    },

    /**
     * 地図上に表示するピン画像データを更新
     * @param {Boolean} force 強制更新する場合はtrue
     */
    $_updatePinImage: async function (force) {
      const projectIds = [
        ...new Set(this.reports.map((d) => d.report_project_id)),
      ]
      const promises = projectIds.map((id) =>
        this.$store
          .dispatch('reportMarker/getImageById', { id, force })
          .catch((error) =>
            this.handleApiError(error, () =>
              this.$log.warn(
                `failed to update pin image of report project ID ${id}.`
              )
            )
          )
      )
      await Promise.allSettled(promises)
    },

    /**
     * 報告書レイヤー更新
     * @param {Boolean} force 再描画を強制する場合は true
     */
    $_updateReportLayer: function (force = false) {
      const props = {
        clustering: this.enableClustering,
        iconAtlas: this.iconAtlas,
        iconMapping: this.iconMapping,
        visible: this.visible,
        zoom: this.zoom,
        getIcon: (d) => {
          if (d.properties.cluster) {
            const cluster = this.clusters.find((cluster) =>
              this.areClustersEqual(d, cluster)
            )
            return cluster?.fixPopup
              ? CLUSTER_ICON_ID.SELECTED
              : CLUSTER_ICON_ID.DEFAULT
          }
          if (this.iconMapping[`${d.properties.report_project_id}`]) {
            return `${d.properties.report_project_id}`
          }
          return 'default'
        },
        getTextColor: (d) => {
          if (d.properties.cluster) {
            const cluster = this.clusters.find((cluster) =>
              this.areClustersEqual(d, cluster)
            )
            return cluster?.fixPopup
              ? CLUSTER_ICON_TEXT_COLOR.SELECTED
              : CLUSTER_ICON_TEXT_COLOR.DEFAULT
          }
        },
        onClick: ({ object }) => this.$_onClickFeature(object),
        onHover: ({ object }) => this.$_onHoverFeature(object),
        onClustered: (data) => this.$_updateClusterInfo(data),
        updateTriggers: {
          getIcon: [this.iconMapping],
        },
      }

      // レイヤー更新を強制するためshallow copy渡す
      this.myRenderer = rendererFactory.createRenderer(
        force ? [...this.reports] : this.reports,
        props
      )
    },

    /**
     * 地物クリック時処理
     * @param {Object} object クリック地物
     */
    $_onClickFeature: function (object) {
      if (this.isCluster(object)) {
        // レイヤーの再描画
        this.$_updateReportLayer(true)
        this.onClickCluster(object)
      } else {
        // クラスタアイコンではないので報告書詳細ダイアログを表示
        this.$_showReportDialog(object.properties.id)
      }
    },

    /**
     * 地物ホバー時処理
     * @param {Object|undefined} object クリック地物|ホバー解除時はundefined
     */
    $_onHoverFeature: function (object) {
      // 地物にホバーしている場合はマウスカーソルをポインタに変更
      this.map.currentMapComponent.changeCursor(object ? 'pointer' : '')

      this.isClusterHoverd = this.isCluster(object)
      if (this.isClusterHoverd) {
        this.onHoverCluster(object)
      } else if (!this.isPopupHoverd) {
        // クラスタアイコンとポップアップにホバーしていないのでポップアップを非表示
        this.clusters = this.clusters.map((cluster) => ({
          ...cluster,
          showPopup:
            cluster.id === this.hoveredCluster?.id ? false : cluster.showPopup,
        }))
      }
    },

    /**
     * クラスタ組成情報を更新
     * @param {Array.<Object>} data クラスタデータ
     */
    $_updateClusterInfo: function (data) {
      this.clusters = data
        .filter((d) => d.properties.cluster)
        .map((d) => ({
          ...d,
          id: d.id || d.properties.id,
          count: d.properties.point_count,
          showPopup: false,
          fixPopup: this.getFixPopupFromCurrentClusterInfo(d),
        }))
        .sort((a, b) => a.id - b.id)
    },

    /**
     * リストのスクロールバーを先頭に移動する
     */
    $_scrollListToTop: function () {
      const scrollElement = this.$refs['report-list-inner']
      scrollElement && scrollElement.scrollToItem(0)
    },

    /**
     * 報告書件数を表示する
     */
    $_showReportTotalCount: function () {
      // URL作成
      var url = RestApiClient.createApiUrl('report/count')
      var params = url.searchParams
      // 検索条件追加
      this.$_addSearchCondition(params)

      RestApiClient.executeGetApi(url)
        .then((json) => {
          this.reportTotalCount = json.data.count
        })
        .catch((error) => {
          this.handleApiError(error)
        })
    },

    /**
     * URLSearchParamsに検索パラメータを追加する(limit, offsetは含まない)
     * @param {URLSearchParams} params パラメータを追加するURLSearchParams
     */
    $_addSearchCondition: function (params) {
      // 報告書プロジェクト
      if (this.currentProjectId) {
        params.append('report_project_id', this.currentProjectId)
      }

      // プレイスID
      if (this.currentPlaceIds.length > 0) {
        params.append('place_id', this.currentPlaceIds)
      }

      // ユーザーID
      if (this.currentUserIds.length > 0) {
        params.append('user_id', this.currentUserIds)
      }

      // グループID
      if (this.currentOrganizationIds.length > 0) {
        params.append('organization_id', this.currentOrganizationIds)
      }

      // 検索期間
      var startDate = this.$_createMoment(this.searchPeriod.startDate)
      if (startDate && startDate.isValid()) {
        startDate.set({
          'hour': 0,
          'minute': 0,
          'second': 0,
          'millisecond': 0,
        })
        params.append(
          'from',
          toServerTz(+startDate, DATETIME_FORMAT_MILLISECOND)
        )
      }
      var endDate = this.$_createMoment(this.searchPeriod.endDate)
      if (endDate && endDate.isValid()) {
        endDate.set({
          'hour': 23,
          'minute': 59,
          'second': 59,
          'millisecond': 999,
        })
        params.append('to', toServerTz(+endDate, DATETIME_FORMAT_MILLISECOND))
      }

      // キーワード
      if (this.searchKeyword) {
        // 半角スペース区切りでor検索ができるため、全角スペースを半角スペースに置き換える
        let keyword = this.searchKeyword.replace(/　/g, ' ')
        params.append('keyword', keyword)
      }

      // 承認済みフラグ(「すべて」の場合は検索パラメータを追加しない)
      if (this.currentCheckedTypes !== CHECKED_TYPES.ALL) {
        let checkedType
        if (this.currentCheckedTypes === CHECKED_TYPES.UNCHECKED) {
          checkedType = 0
        } else if (this.currentCheckedTypes === CHECKED_TYPES.CHECKED) {
          checkedType = 1
        }
        params.append('checked_flg', checkedType)
      }
    },

    /**
     * 報告書プロジェクトが変更された時の処理
     * @param {number} newProjectId 新たに選択されたプロジェクトID
     */
    $_changeReportProject: function (newProjectId) {
      this.currentProjectId =
        newProjectId !== ALL_PROJECTS_ID ? newProjectId : null
      this.$_showReportData()
    },

    /**
     * プレイス選択コンポーネントの値を変更する
     * @param {Array.<Number>} ids プレイスID配列
     */
    $_changeSelectedPlaces: function (ids) {
      this.$refs['place-selector'].setValue(ids)
    },

    /**
     * プレイス選択コンポーネントで検索対象のプレイスが確定した時の処理
     * @param {Array} selectedPlaces 選択されたプレイス情報のリスト
     */
    $_fixSelectedPlaces: function (selectedPlaces) {
      // 選択中のプレイスIDを更新する
      this.currentPlaceIds = []
      selectedPlaces.forEach((place) => {
        this.currentPlaceIds.push(place.id)
      })

      // 報告書を再検索する
      this.$_showReportData()
    },

    /**
     * 検索項目変更時の処理
     * @param {Array.<String>} selectedKeywordTarget // 選択された検索項目ID配列
     */
    $_onKeywordTargetChange: function (selectedKeywordTarget) {
      this.$store.dispatch('place/setKeywordTargets', selectedKeywordTarget)
    },

    /**
     * ユーザー選択コンポーネントで検索対象のユーザーが確定した時の処理
     * @param {Array.<Object>} retValue ユーザー/グループID, 名前の配列
     */
    $_fixSelectedUsers: function (retValue) {
      if (!retValue) {
        this.currentUserIds = []
        this.currentOrganizationIds = []
        this.$_showReportData()
        return
      }

      const selectedUserIds = retValue
        .filter((value) => value.type === 'user')
        .map((value) => value.id)
      const selectedOrganizationIds = retValue
        .filter((value) => value.type === 'organization')
        .map((value) => value.id)
      // 変更されていない場合は何もしない
      if (
        _.isEqual(this.currentUserIds, selectedUserIds) &&
        _.isEqual(this.currentOrganizationIds, selectedOrganizationIds)
      ) {
        return
      }
      this.currentUserIds = selectedUserIds
      this.currentOrganizationIds = selectedOrganizationIds
      this.$_showReportData()
    },

    /**
     * 検索対象期間が変更された時の処理
     * @param {string} startDate 開始日文字列(yyyy-mm-dd)
     * @param {string} startTime 開始時刻文字列(hh:mm)
     * @param {string} endDate 終了日文字列(yyyy-mm-dd)
     * @param {string} endTime 終了時刻文字列(hh:mm)
     * @param {string} errorMessage バリデーションエラーメッセージ
     */
    $_changeSearchPeriod: function (
      startDate,
      startTime,
      endDate,
      endTime,
      errorMessage
    ) {
      if (errorMessage) {
        // バリデーションエラーを表示する
        this.$alert.fire({
          icon: 'error',
          title: this.$t('theReport.message.invalidReportingDate'),
          text: errorMessage,
        })
      } else {
        // 指定された期間で報告書を検索する
        this.searchPeriod.startDate = this.$_parseDate(startDate)
        this.searchPeriod.endDate = this.$_parseDate(endDate)
        this.$_showReportData()
      }
    },

    /**
     * 日付文字列(yyyy-mm-dd)から日付オブジェクトを作成する
     * @param {string} targetDate 対象日付文字列
     * @return {Date} 生成した日付、ただしtargetDateがnullの場合はnullを返却する
     */
    $_parseDate: function (targetDate) {
      return targetDate ? moment(targetDate).toDate() : null
    },

    /**
     * Dateオブジェクトからmomentを生成する
     * @param {Date} dateValue 元の日付
     * @return {moment} moment、ただしdateValueがnullの場合はnull
     */
    $_createMoment: function (dateValue) {
      if (!dateValue) {
        return null
      }
      return moment(dateValue)
    },

    /**
     * キーワード検索実行時処理
     * @param {String} value キーワード
     */
    $_onSearchKeyword: function (value) {
      this.searchKeyword = value
      this.isKeywordChanged && this.$_showReportData()
    },

    /**
     * リロードボタンクリック時処理
     */
    $_onClickReload: function () {
      this.isReloading = true
      this.$_showReportData()
    },

    /**
     * 報告書詳細ダイアログを表示する
     * @param {Number} recordId 表示対象の報告書のレコードID
     */
    $_showReportDialog: function (recordId) {
      // ダイアログを表示する
      this.$refs['report-detail'].showModal(recordId)
    },

    /**
     * プレイス詳細ダイアログを表示する
     * @param {Number} recordId 表示対象のプレイスレコードのID
     */
    $_showPlaceDialog: function (recordId) {
      // ダイアログを表示する
      this.$refs['place-detail'].showModal(recordId)
    },

    /**
     * 報告書カードをクリックした時の処理
     * @param {number} timelineType タイムラインタイプ(使用しない)
     * @param {number} recordId クリックしたカードのレコードID
     */
    $_onClickCardBody: function (timelineType, recordId) {
      if (!this.map) return
      // 地図のフォーカスを選択したデータに設定する
      const bounds = this.$_getSpecificReportBounds(recordId)
      this.map.fitBounds(bounds)
    },

    /**
     * 特定の報告書のboundsを取得する
     * @param {Number} id 報告書ID
     * @returns {Object} bounds
     */
    $_getSpecificReportBounds: function (id) {
      const data = this.reports.find((m) => m.id === id)
      if (!data) return null
      const coordinates = data.geom.geometry.coordinates
      return {
        sw: coordinates,
        ne: coordinates,
      }
    },

    /**
     * 報告書カードのタイトルをクリックした時の処理
     * @param {number} timelineType タイムラインタイプ(使用しない)
     * @param {number} recordId クリックしたカードのレコードID
     */
    $_onClickCardTitle: function (timelineType, recordId) {
      // 詳細ダイアログを表示する
      this.$_showReportDialog(recordId)
    },

    /**
     * 報告書カードの詳細ボタンをクリックした時の処理
     * @param {number} timelineType タイムラインタイプ(使用しない)
     * @param {number} recordId クリックしたカードのレコードID
     */
    $_onClickCardDetail: function (timelineType, recordId) {
      // 詳細ダイアログを表示する
      this.$_showReportDialog(recordId)
    },

    /**
     * 報告書詳細ダイアログを非表示にする時の処理
     * @param {boolean} isUpdated ダイアログで報告書を更新した場合はtrue
     */
    $_onHideReportDetail: function (isUpdated) {
      // 報告書データを更新されている場合は、報告書データを再取得する
      if (isUpdated) {
        this.$_showReportData()
      }
    },

    /**
     * プレイス詳細非表示時処理
     * @param {Boolean} isUpdated 表示されていたプレイスが更新された場合はtrue
     */
    $_onHidePlaceDetail: function (isUpdated) {
      if (isUpdated) {
        // 地図の強制再描画
        const deck = this.map.getMapDeckController()
        deck && deck.render(true)
        // リスト更新
        this.$_showReportData()
      }
    },

    /**
     * 編集ダイアログを表示する
     */
    $_showEditDialog: function () {
      this.$refs['report-editor'].showModal()
    },

    /**
     * 報告書編集が量ときの処理
     */
    $_onReportEditEnd: function () {
      this.$_showReportData()
    },

    /**
     * リストビューの表示・非表示を切り替える
     */
    $_toggleListViewShown: function () {
      this.isListViewShown = !this.isListViewShown
    },

    /**
     * 1ページあたりの表示件数が変更された時の処理
     */
    $_onChangeListLimit: function (value) {
      this.listLimit = value
      this.$_showReportData()
    },

    /**
     * 地図ページへ遷移する
     * @param {Object} params 遷移時に引き渡すパラメータ
     */
    $_showMember: function (params) {
      this.$router.push({
        name: 'member',
        params,
      })
    },

    /**
     * モーダル重畳状態変更時処理
     * @param {Boolean} value モーダル重畳状態
     */
    $_onModalOverlayChanged: function (value) {
      this.isModalOverlaid = value
    },

    /**
     * ローディングを表示する
     */
    $_showLoading: function () {
      this.isLoading = true
    },

    /**
     * ローディングを非表示にする
     */
    $_hideLoading: function () {
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../assets/scss/parts/container';
@use '../assets/scss/parts/tool-bar';
@use '../assets/scss/parts/title-bar';

$-list-header-height: 52px;
$-list-footer-height: calc(
  #{$pagination-height} + #{$list-footer-padding-top} +
    #{$list-footer-border-width}
);

#the-reports {
  width: 100%;
  height: 100%;
}

.container-report {
  ::v-deep .row {
    margin: 0;
  }
}

.content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: calc(100% - #{$tool-bar-height});
  margin-right: 0;
}

.view-list {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: #ffffff;
  transition: 0.3s;
  z-index: 1; // ポップアップより前面に配置
}

.tool-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1; // ポップアップより前面に配置
}

.tool-bar-form {
  width: 100%;
}

.title-bar {
  padding: 0 10px 0 16px;
}

.title-bar-action {
  column-gap: 8px;
}

.button-create {
  @include mixin-button;
  & {
    height: $button-size;
    column-gap: 4px;
    padding: 0 8px 0 6px;
    font-size: $font-size-small;
  }
}

.list-wrapper {
  height: calc(100% - #{$title-bar-height});
  padding: 0 10px 6px 10px;
  flex-grow: 1;
  flex-basis: 0;
}

.list-header {
  height: $-list-header-height;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.list-inner {
  height: calc(100% - #{$-list-header-height} - #{$-list-footer-height});
  overflow-y: scroll;
  @include mixin-scrollbar;

  ::v-deep .resize-observer {
    display: none;
  }
}

.report-detail-content {
  width: 100%;

  .spacer {
    height: 20px;
  }
}

.list-footer {
  width: 100%;
  height: $-list-footer-height;
  padding-top: $list-footer-padding-top;
  background-color: #fff;
  border-top: $list-footer-border-width solid #eaecef;
}

.list-limit {
  padding: 0 30px 0 0;
}

.report-pagination {
  @include mixin-pagination;
}

.view-map {
  display: -webkit-box !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  height: 100%;
}

.list-tab {
  position: absolute;
  left: 0;
  top: 16px;
}

#report-map-control {
  ::v-deep .control-wrapper {
    &.left-top-wrapper,
    &.left-bottom-wrapper {
      padding-left: 40px;
    }

    .map-control-ui {
      pointer-events: auto;
    }
  }
}
</style>
